var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('h1',[_vm._v("404")]),_c('a',{on:{"click":_vm.goBack}},[_vm._v("Go Back")])])])}
var staticRenderFns = []

export { render, staticRenderFns }